var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReactiveXDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3867 153.535C35.6479 101.757 61.3858 51.8202 120.459 45.1771C112.313 36.4727 101.184 36.4073 96.064 37.4661C87.0233 40.3473 87.3071 46.1976 77.0522 53.7544C66.8573 59.5773 61.7371 55.1181 54.3105 61.1545C46.8998 67.1459 52.0708 80.8998 48.9628 83.5738C45.8776 88.9216 36.3072 93.6856 34.565 100.44C33.1253 109.078 38.473 115.249 38.2673 122.653C38.8844 128.824 32.1244 132.313 33.0956 137.314C36.0048 145.484 41.6121 150.402 44.2555 152.668C44.8617 153.095 45.5019 154.148 45.3867 153.535Z",
    fill: "#FF0090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.501 81.8602C148.343 81.8602 146.593 80.1103 146.593 77.9522C146.593 75.7941 148.343 74.0443 150.501 74.0443C152.659 74.0443 154.409 75.7941 154.409 77.9522C154.409 80.1103 152.659 81.8602 150.501 81.8602ZM47.6667 159.183C38.3078 114.182 67.2683 76.5811 123.351 95.0925C156.259 114.344 197.655 113.09 199.522 100.646C204.13 85.7275 178.542 54.9845 140.285 46.9629C64.3888 32.1538 23.4723 114.182 47.6667 159.183Z",
    fill: "url(#paint0_radial_404_333)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.166 164.201C183.436 165.422 194.133 162.717 204.047 154.637C189.07 171.342 170.343 179.742 148.856 182.027C159.115 190.749 169.009 194.678 178.474 192.997C152.174 200.254 130.139 192.266 103.335 165.573C101.931 172.758 109.521 183.954 117.343 191.101C71.9557 171.424 67.9766 110.127 123.322 95.0489C65.95 67.4845 33.5092 121.042 49.4478 164.938C65.0427 198.747 106.6 224.774 152.146 219.05C174.27 216.34 207.307 201.087 220.803 164.938C211.291 173.474 194.288 180.908 186.701 181.478C212.381 168.645 226.243 146.837 222.352 117.032C217.033 129.696 210.015 139.421 201.236 146.101C219.884 117.032 216.684 102.007 202.881 85.4937C212.754 112.644 199.983 142.777 172.166 164.201Z",
    fill: "url(#paint1_radial_404_333)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.988 195.479C157.039 195.115 163.405 198.058 151.098 194.8C138.791 191.542 126.26 188.402 103.335 165.572C101.931 172.758 109.521 183.954 117.343 191.1C138.46 205.827 124.099 198.94 156.274 210.062C158.856 204.923 158.988 200.356 158.988 195.479Z",
    fill: "url(#paint2_linear_404_333)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.078 79.8355C118.078 79.8355 120.875 75.7066 121.964 73.8444C123.298 71.5625 125.348 67.4032 125.348 67.4032C125.348 67.4032 103.815 60.3782 98.5309 59.521C82.1045 63.785 82.0447 70.667 91.2284 81.2008C92.2502 82.3732 118.078 79.8355 118.078 79.8355Z",
    fill: "url(#paint3_linear_404_333)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_404_333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.219 88.3392) scale(143.203 102.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D008E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_404_333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.48 91.4028) scale(145.151 109.801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57008E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291746,
    stopColor: "#5C008E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_404_333",
    x1: 113.347,
    y1: 165.572,
    x2: 139.005,
    y2: 208.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669713,
    stopColor: "#E50090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827148,
    stopColor: "#D6008F",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10090",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_404_333",
    x1: 111.214,
    y1: 75.2561,
    x2: 107.491,
    y2: 68.1246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2008F",
    stopOpacity: 0.15134
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400351,
    stopColor: "#F70090",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648996,
    stopColor: "#F60090",
    stopOpacity: 0.891668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0090"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactiveXDark);
export default __webpack_public_path__ + "static/media/ReactiveX-Dark.aad66707083e55d31dbdeebc4ae8b3f4.svg";
export { ForwardRef as ReactComponent };